/**
 * Il glossario: le stesse spiegazioni delle parole, tutte in una pagina.
 *
 * **Una vista, non un secondo testo.** Ogni voce viene dal dizionario di
 * `explain.ts`, lo stesso che alimenta il segno «?» accanto alla parola. Se
 * il glossario dicesse una cosa e la spiegazione accanto alla parola un'altra,
 * una delle due mentirebbe — e sarebbe quella che si legge di meno.
 *
 * **Non e' il manuale.** Il manuale dice come si lavora; qui si dice che cosa
 * significano le parole. Una voce che cominciasse a descrivere una procedura
 * sta nel posto sbagliato.
 *
 * Aperta a tutti i ruoli: non c'e' una parola che uno possa vedere e un altro
 * no, ci sono solo schermate diverse in cui incontrarla.
 */
import { GLOSSARY, conceptSays, conceptTerm } from '../i18n/explain'
import { useT } from '../i18n/LocaleProvider'

export function Glossary(): JSX.Element {
  const t = useT()
  return (
    <main className="glossario">
      <h2>{t('title.glossary')}</h2>
      <p className="t-read">{t('glossary.intro')}</p>
      {GLOSSARY.map((group) => (
        <section key={group.section} aria-labelledby={`sez-${group.section}`}>
          <h3 id={`sez-${group.section}`}>{t(group.section)}</h3>
          <dl>
            {group.concepts.map((about) => (
              // L'ancora e' il concetto stesso: il segno «?» accanto alla
              // parola porta qui, alla voce, non in cima alla pagina.
              <div key={about} id={about} className="glossario-voce">
                <dt>{conceptTerm(t, about)}</dt>
                <dd>{conceptSays(t, about)}</dd>
              </div>
            ))}
          </dl>
        </section>
      ))}
    </main>
  )
}
